import type { ErrorJson } from './index';

export class FeatureError<T extends ErrorJson = ErrorJson> extends Error {
  constructor(
    public json: T,
    cause?: unknown,
  ) {
    super(json.title, { cause });
    json.priority = json.priority ?? 1;
  }
}

export const isFeatureError = (e: unknown): e is FeatureError => {
  if (e instanceof FeatureError) {
    return true;
  } else {
    return false;
  }
};
